// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"a84867c5","418":"931023e4","453":"8ab44547","480":"3a6f39b4","638":"b02228b2","854":"692201c8"}[chunkId] + ".chunk.js";
};